(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    const mediaQuery = window.matchMedia('(max-width: 749px)');
    const blockSelector = '.product-information .buy-buttons-block--sticky-mobile';
    const fixedBarSelector = `${blockSelector} .product-form-buttons__bar--fixed`;
    let resizeObserver;
    let mutationObserver;

    const getSourceBar = (block) =>
      block.querySelector('.product-form-buttons__bar:not(.product-form-buttons__bar--fixed)');

    const moveWishlistIntoBar = () => {
      document.querySelectorAll(blockSelector).forEach((block) => {
        const bar = getSourceBar(block);
        if (!bar) return;

        block.querySelectorAll('.wishlist-button-wrapper').forEach((wishlist) => {
          if (wishlist.closest('.product-form-buttons__bar--fixed')) return;
          if (!bar.contains(wishlist)) bar.appendChild(wishlist);
        });
      });
    };

    const syncStickyHeight = () => {
      const bar = document.querySelector(fixedBarSelector);

      if (!bar || !mediaQuery.matches) {
        document.documentElement.style.removeProperty('--buy-buttons-sticky-height');
        return;
      }

      document.documentElement.style.setProperty('--buy-buttons-sticky-height', `${bar.offsetHeight}px`);
    };

    const stripCloneBehavior = (clone) => {
      clone.querySelectorAll('quantity-selector-component, add-to-cart-component').forEach((element) => {
        const replacement = document.createElement('div');
        replacement.className = element.className;
        while (element.firstChild) replacement.appendChild(element.firstChild);
        element.replaceWith(replacement);
      });

      clone.querySelectorAll('*').forEach((element) => {
        Array.from(element.attributes).forEach((attribute) => {
          if (
            attribute.name.startsWith('on:') ||
            attribute.name === 'ref' ||
            attribute.name === 'id' ||
            attribute.name === 'name'
          ) {
            element.removeAttribute(attribute.name);
          }
        });
      });

      clone.querySelectorAll('button[type="submit"]').forEach((button) => {
        button.type = 'button';
      });
    };

    const proxyClick = (sourceElement, cloneElement) => {
      if (!sourceElement || !cloneElement) return;

      cloneElement.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        sourceElement.click();
      });
    };

    const bindStickyClone = (source, clone) => {
      const sourceInput = source.querySelector('.quantity-selector input, input[type="number"]');
      const cloneInput = clone.querySelector('.quantity-selector input, input[type="number"]');
      const sourceMinus = source.querySelector('.quantity-minus');
      const sourcePlus = source.querySelector('.quantity-plus');
      const cloneMinus = clone.querySelector('.quantity-minus');
      const clonePlus = clone.querySelector('.quantity-plus');
      const sourceAdd = source.querySelector('.add-to-cart-button');
      const cloneAdd = clone.querySelector('.add-to-cart-button');
      const sourceWishlist = source.querySelector('.wishlist-btn, .wishlist-button-wrapper button, .wishlist-button-wrapper a');
      const cloneWishlist = clone.querySelector('.wishlist-btn, .wishlist-button-wrapper button, .wishlist-button-wrapper a');

      const copyQuantity = () => {
        if (sourceInput && cloneInput) cloneInput.value = sourceInput.value;
      };

      proxyClick(sourceMinus, cloneMinus);
      proxyClick(sourcePlus, clonePlus);
      proxyClick(sourceAdd, cloneAdd);
      proxyClick(sourceWishlist, cloneWishlist);

      cloneMinus?.addEventListener('click', () => requestAnimationFrame(copyQuantity));
      clonePlus?.addEventListener('click', () => requestAnimationFrame(copyQuantity));

      if (sourceInput && cloneInput) {
        sourceInput.addEventListener('input', copyQuantity);
        sourceInput.addEventListener('change', copyQuantity);
        cloneInput.addEventListener('input', () => {
          sourceInput.value = cloneInput.value;
          sourceInput.dispatchEvent(new Event('input', { bubbles: true }));
          sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
        copyQuantity();
      }

      if (sourceAdd && cloneAdd) {
        const syncDisabled = () => {
          cloneAdd.disabled = sourceAdd.disabled;
        };
        syncDisabled();
        new MutationObserver(syncDisabled).observe(sourceAdd, { attributes: true, attributeFilter: ['disabled'] });
      }
    };

    const createStickyClone = (block) => {
      const source = getSourceBar(block);
      if (!source) return;

      block.querySelector('.product-form-buttons__bar--fixed')?.remove();

      const clone = source.cloneNode(true);
      clone.classList.add('product-form-buttons__bar--fixed');
      stripCloneBehavior(clone);
      bindStickyClone(source, clone);
      block.appendChild(clone);
    };

    const destroyStickyClones = () => {
      document.querySelectorAll(fixedBarSelector).forEach((element) => element.remove());
      document.documentElement.style.removeProperty('--buy-buttons-sticky-height');
    };

    const observeStickyBar = () => {
      if (resizeObserver) resizeObserver.disconnect();
      if (mutationObserver) mutationObserver.disconnect();

      if (!mediaQuery.matches) {
        destroyStickyClones();
        return;
      }

      moveWishlistIntoBar();

      resizeObserver = new ResizeObserver(syncStickyHeight);
      mutationObserver = new MutationObserver((mutations) => {
        const shouldRefresh = mutations.some((mutation) => {
          const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
          if (target?.closest('.product-form-buttons__bar--fixed')) return false;

          return Array.from(mutation.addedNodes).some((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return false;
            if (node.matches('.product-form-buttons__bar--fixed')) return false;

            return node.matches('.wishlist-button-wrapper') || node.querySelector('.wishlist-button-wrapper');
          });
        });

        if (shouldRefresh) {
          moveWishlistIntoBar();
          document.querySelectorAll(blockSelector).forEach((block) => {
            createStickyClone(block);
            const fixedBar = block.querySelector('.product-form-buttons__bar--fixed');
            if (fixedBar) resizeObserver.observe(fixedBar);
          });
        }

        syncStickyHeight();
      });

      document.querySelectorAll(blockSelector).forEach((block) => {
        createStickyClone(block);
        const fixedBar = block.querySelector('.product-form-buttons__bar--fixed');
        if (fixedBar) resizeObserver.observe(fixedBar);
        mutationObserver.observe(block, { childList: true, subtree: true });
      });

      syncStickyHeight();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeStickyBar, { once: true });
    } else {
      observeStickyBar();
    }

    mediaQuery.addEventListener('change', observeStickyBar);
    document.addEventListener('shopify:section:load', observeStickyBar);
    [500, 1500, 3000].forEach((delay) => setTimeout(observeStickyBar, delay));
  })();
  } catch(e) { console.error(e); }
})();

})();
